import * as React from 'react';
import * as Redux from 'redux';
import { IState } from '../../reducers/index'
import { CategoryTerm } from './category-term'
import { ICategoryResult, ICategories } from '../../state-helpers/categories';
import * as _ from 'lodash';
import { updatedSelectedCategoryCount } from '../../reducers/categories-model';
import {
  setSearchTerm,
  setPage,
  updateSearchCategory,
  setMobileCategoriesVisibility
} from '../../actions/index';

export interface IToggleFacetsProps {
  categories: ICategoryResult[];
  dispatch: Redux.Dispatch<IState>;
  onUpdateSearchCategory(categories: ICategoryResult[]): void;
  selectedCategoryCount: number;
  mobileCategoriesVisibility: boolean;
  categoriesModel: ICategories;
  numberOfResults: number
}

export class ToggleFacets extends React.Component<IToggleFacetsProps, any> {
  toggleMobileCategories(e) {
    // set body to fixed when mobile filters panel is open
    document.querySelector('body').classList.toggle('fixed');
    this.props.dispatch(setMobileCategoriesVisibility(!this.props.mobileCategoriesVisibility));
  }

  render() {
    let boundToggleMobileCategories = this.toggleMobileCategories.bind(this);

    return (
      <button className="search-facet-header-toggle" onClick={boundToggleMobileCategories} disabled={this.props.numberOfResults != 0 ? false : true}>

        <h4 className="search-facet-header-text">

          { getCategorySelectedCount(this.props.categories) > 0
                    ? <span className="search-facet-header-selected-count">({getCategorySelectedCount(this.props.categories)})</span>
              : null
          }

          Filter Results

                    <div className="facet-controls">

            <svg className="svg-icon open" aria-hidden="true" focusable="false">
              <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-refine" />
            </svg>

            <span className="mobile-facets-close">
              <span className="mobile-facets-close-text">Done</span>
              <svg className="svg-icon close" aria-hidden="true" focusable="false">
                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-close" />
              </svg>
            </span>

          </div>
        </h4>
      </button>
    );
  }
}

function getCategorySelectedCount(categories: ICategoryResult[]) {
  var currentCategories = _.clone(categories);
  var categoryCount = 0;

  for (var category = 0; category < currentCategories.length; category++) {
    var currentFilter = currentCategories[category];

    for (var filter = 0; filter < currentFilter.terms.length; filter++) {
      var currentTerm = currentFilter.terms[filter];

        if (currentTerm.selected) {
        categoryCount++;
      }
    }
  }
  return categoryCount;
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/search-page/components/categories/facets-toggle.tsx